import AccountConfirmation from "../components/smart/AccountConfirmation/AccountConfirmation";
import SmartAdminRegistration from "../components/smart/AdminRegistration/AdminRegistration";
import PasswordDefine from "../components/smart/PasswordDefine/PasswordDefine";
import { appStudy } from "../config";
import { profiles } from "../modules/constants";
import AccessDenied from "../pages/AccessDenied";
import LandingPage from "../pages/Landing";
import NotFound from "../pages/NotFound";
import Studies from "../pages/Studies";
import Unauthorized from "../pages/Unauthorized";
import * as studyRoutes from "./studies/index";
import SessionTimeoutSimulator from "../components/smart/SessionTimeoutSimulator/SessionTimeoutSimulator"; // Update this import

/**
 * Matches current study from url to an exported array of routes from all studies index. (Removes hyphens)
 * Eg: https://ux007-cl401.rest.of.url automatically loads ux007cl401 from studyRotues index as routes
 * @param {*} formalStudyName
 */
export const getStudyRoutes = (formalStudyName) => {
  try {
    return studyRoutes[formalStudyName.replace("-", "")];
  } catch (error) {
    return [];
  }
};

export const root = "/home";
const appStudyRoutes = getStudyRoutes(appStudy);
export const onRouteChange = appStudyRoutes?.onRouteChange;
export const onProtectedRouteChange = appStudyRoutes?.onProtectedRouteChange;

export default [
  {
    path: "/home",
    component: LandingPage,
    withNavbar: true,
    withSidebar: false,
  },
  ...(appStudyRoutes?.routesArray || appStudyRoutes || []),
  {
    path: "/studies",
    component: Studies,
    authorize: [
      profiles.participant,
      profiles.contentAdmin,
      profiles.studyAdmin,
      profiles.pi,
      profiles.dietitian,
      profiles.siteCoordinator,
      profiles.medicalMonitor,
      profiles.sponsor,
      profiles.siteMonitor,
    ],
    redirectNonAuthorized: "/unauthorized",
    withNavbar: true,
    withSidebar: false,
  },
  // Add the new route for session timeout simulation
  {
    path: "/timeout",
    component: SessionTimeoutSimulator,
    withNavbar: false,
    withSidebar: false,
  },
  //Old Routes
  {
    path: "/recover/:token/:email",
    component: PasswordDefine,
  },
  {
    path: "/confirmation/:token",
    component: AccountConfirmation,
  },
  {
    path: "/invite/:token/:email",
    component: SmartAdminRegistration,
  },
  {
    path: "/unauthorized",
    withNavbar: true,
    component: Unauthorized,
  },
  {
    path: "/accessdenied",
    withNavbar: true,
    component: AccessDenied,
  },
  {
    path: "/*",
    withNavbar: true,
    component: NotFound,
  },
];
